export const AxelLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="16"
    viewBox="0 0 31 16"
    fill="none"
  >
    <path
      d="M17.8901 0.932983C18.708 0.933018 19.4669 1.36195 19.8884 2.06292L22.2753 6.03372C22.4149 6.26588 22.4197 6.55529 22.2864 6.79113C22.153 7.02702 21.9024 7.17353 21.6314 7.17353H5.84194C5.57094 7.17353 5.32034 7.02701 5.18693 6.79113C5.05369 6.5553 5.05845 6.26588 5.19803 6.03372L7.58495 2.06168C8.00648 1.36076 8.76539 0.932949 9.58331 0.932983H17.8901ZM9.58331 2.43668C9.29304 2.43667 9.02358 2.58882 8.87402 2.83759L7.17171 5.66859H20.3016L18.5993 2.83759C18.4498 2.58886 18.1803 2.4367 17.8901 2.43668H9.58331Z"
      fill="#2660E6"
    />
    <path
      d="M0.352539 7.99999V6.42105C0.352539 6.00579 0.689754 5.66858 1.10501 5.66858H25.5787C28.174 5.66858 30.2785 7.77309 30.2785 10.3684V11.9474C30.2785 12.3626 29.9413 12.6998 29.5261 12.6998H5.05237C2.45705 12.6998 0.352539 10.5953 0.352539 7.99999ZM1.85747 7.99999C1.85747 9.76481 3.28755 11.1949 5.05237 11.1949H28.7736V10.3684C28.7736 8.6036 27.3435 7.17351 25.5787 7.17351H1.85747V7.99999Z"
      fill="#2660E6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5789 11.9474C10.5789 13.2555 9.51841 14.3158 8.21068 14.3158C6.90251 14.3158 5.84204 13.2555 5.84204 11.9474C5.84204 10.6393 6.90251 9.57898 8.21068 9.57898C9.51841 9.57898 10.5789 10.6393 10.5789 11.9474Z"
      fill="white"
    />
    <path
      d="M9.82644 11.9473C9.82644 11.0544 9.10295 10.3314 8.21049 10.3314C7.31759 10.3315 6.59453 11.0546 6.59453 11.9473C6.59453 12.84 7.31759 13.5631 8.21049 13.5633C9.10295 13.5633 9.82644 12.8402 9.82644 11.9473ZM11.3314 11.9473C11.3314 13.6707 9.93348 15.0682 8.21049 15.0682C6.48725 15.0681 5.0896 13.6707 5.0896 11.9473C5.0896 10.2239 6.48725 8.82654 8.21049 8.82642C9.93348 8.82642 11.3314 10.2239 11.3314 11.9473Z"
      fill="#2660E6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.7896 11.9474C24.7896 13.2555 23.7291 14.3158 22.4214 14.3158C21.1132 14.3158 20.0527 13.2555 20.0527 11.9474C20.0527 10.6393 21.1132 9.57898 22.4214 9.57898C23.7291 9.57898 24.7896 10.6393 24.7896 11.9474Z"
      fill="white"
    />
    <path
      d="M24.0371 11.9473C24.0371 11.0544 23.3136 10.3314 22.4212 10.3314C21.5283 10.3315 20.8052 11.0546 20.8052 11.9473C20.8052 12.84 21.5283 13.5631 22.4212 13.5633C23.3136 13.5633 24.0371 12.8402 24.0371 11.9473ZM25.5421 11.9473C25.5421 13.6707 24.1442 15.0682 22.4212 15.0682C20.6979 15.0681 19.3003 13.6707 19.3003 11.9473C19.3003 10.2239 20.6979 8.82654 22.4212 8.82642C24.1442 8.82642 25.5421 10.2239 25.5421 11.9473Z"
      fill="#2660E6"
    />
  </svg>
);
